import { z } from "zod"

// Version 1 ---------------------

export const ButtonBaseElementV1 = z.object({
  id: z.string(),
  name: z.literal("buttonBase"),
  settings: z
    .object({
      text: z.string().optional(),
    })
    .optional(),
})

export type TButtonBaseElementV1 = z.infer<typeof ButtonBaseElementV1>

// Latest ---------------------
export const ButtonBaseElement = ButtonBaseElementV1
export type TButtonBaseElement = TButtonBaseElementV1
